import { db } from '../config/firebase';
import { 
  collection, 
  addDoc, 
  updateDoc, 
  doc, 
  serverTimestamp, 
  getDoc, 
  setDoc 
} from 'firebase/firestore';

// Session tracking
// export const startUserSession = async (userId, userEmail) => {
//   const sessionRef = await addDoc(collection(db, 'sessions'), {
//     userId,
//     userEmail,
//     startTime: serverTimestamp(),
//     endTime: null,
//     isActive: true
//   });
//   return sessionRef.id;
// };

// export const endUserSession = async (sessionId) => {
//   const sessionRef = doc(db, 'sessions', sessionId);
//   const sessionSnap = await getDoc(sessionRef);

//   if (sessionSnap.exists()) {
//     const startTime = sessionSnap.data().startTime.toDate();
//     const endTime = new Date();
//     const duration = Math.floor((endTime - startTime) / 1000); // Duration in seconds

//     await updateDoc(sessionRef, {
//       endTime: serverTimestamp(),
//       isActive: false,
//       duration
//     });
//   }
// };

// // User analytics
// export const updateUserAnalytics = async (userId, data) => {
//   const userAnalyticsRef = doc(db, 'userAnalytics', userId);
//   const docSnap = await getDoc(userAnalyticsRef);

//   if (!docSnap.exists()) {
//     await setDoc(userAnalyticsRef, {
//       firstSeen: serverTimestamp(),
//       totalSessions: 1,
//       lastActive: serverTimestamp(),
//       ...data
//     });
//   } else {
//     await updateDoc(userAnalyticsRef, {
//       totalSessions: docSnap.data().totalSessions + 1,
//       lastActive: serverTimestamp(),
//       ...data
//     });
//   }
// };

// Retention analytics
export const updateUserRetention = async (userId) => {
  const userRetentionRef = doc(db, 'userRetention', userId);
  const docSnap = await getDoc(userRetentionRef);

  if (!docSnap.exists()) {
    await setDoc(userRetentionRef, {
      firstSeen: serverTimestamp(),
      lastSeen: serverTimestamp(),
      GenerationCount: 1,
    });
  } else {
    await updateDoc(userRetentionRef, {
      lastSeen: serverTimestamp(),
      GenerationCount: docSnap.data().GenerationCount + 1,
    });
  }
};

// Enhanced generation logging
export const logEnhancedGeneration = async (userId, userEmail, voiceId, characterCount, text, dl_url, flowValue, paceValue, success) => {
  try {
    await addDoc(collection(db, 'generations2'), {
      userId,
      userEmail,
      voiceId,
      characterCount,
      text,
      dl_url,
      flowValue,
      paceValue, // Added pace value to the logging
      success: success || "failed", // Default to "failed" if success is undefined
      timestamp: serverTimestamp(),
    });
  } catch (error) {
    // Log error but don't throw it to prevent disrupting the app flow
    console.error("Error logging to generations2 collection:", error);
  }
};

// Download tracking
export const logDownload = async (userId, generationId, voiceId) => {
  await addDoc(collection(db, 'downloads'), {
    userId,
    generationId,
    voiceId,
    timestamp: serverTimestamp(),
  });
};
